/* eslint-disable no-case-declarations */
import { Component } from 'react';
import { connect } from 'react-redux';
import { DashboardAction, manageAdminRolesActions } from 'Actions/index';
import { ReactComponent as Audio } from 'assets/images/svg/incomingcalls.svg';
import { ReactComponent as Videocamera } from 'assets/images/svg/videocamera.svg';
import { ReactComponent as Groups } from 'assets/images/svg/groups.svg';
import { ReactComponent as Broadcasts } from 'assets/images/svg/broadcasts.svg';
import { ReactComponent as User } from 'assets/images/svg/user.svg';
import { ReactComponent as Platform } from 'assets/images/svg/platform.svg';
import { ReactComponent as Calendar } from 'assets/images/svg/calendar.svg';

import { ReactComponent as audio_call_icon } from 'assets/images/svg/audio_call_icon.svg';
import { ReactComponent as current_user_icon } from 'assets/images/svg/current_user_icon.svg';
import { ReactComponent as total_group_icon } from 'assets/images/svg/total_group_icon.svg';
import { ReactComponent as inactive_user_icon } from 'assets/images/svg/inactive_user_icon.svg';
import { ReactComponent as new_user_icon } from 'assets/images/svg/new_user_icon.svg';
import { ReactComponent as video_call_icon } from 'assets/images/svg/video_call_icon.svg';
import { ModuleActions } from 'Constants/Modules.constants';

class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      rolesDropdown: [],
      currentUsers: 0,
      newUsers: 0,
      messagesSent: 0,
      audioCall: {
        minutes: 0,
        calls: 0,
      },
      videoCall: {
        minutes: 0,
        calls: 0,
      },
      groupCount: 0,
      broadcastCount: { user: 0, admin: 0 },
      usersByPlatform: 0,
      unreadFeedbackCount: 0,
      selectedUserPlatform: 'web',
      selectedAdminType: '',
    }
  }

  componentDidMount() {
    this.props.fetchDashboard();
    this.props.fetchAdminRoles();
  }

  componentDidUpdate(prevProps) {
    const { adminRoleId, adminRoles } = this.props;
    const { adminRoleId: prevAdminRoleId } = prevProps;
    if(prevAdminRoleId !== adminRoleId) {
      this.handleSubAdminState();
      this.setState({ rolesDropdown: adminRoles });
    }
    if(prevProps.dashboardId !== this.props.dashboardId) { 
      const {
        currentUsers,
        newUsers,
        messagesSent,
        audioCall,
        videoCall,
        groupCount,
        broadcastCount,
        usersByPlatform,
      } = this.props.dashboardList.data;
      this.setState({        
        currentUsers: currentUsers,
        newUsers: newUsers.today,
        messagesSent: messagesSent?.text,
        audioCall: { calls: audioCall },
        videoCall: { calls: videoCall },
        groupCount: groupCount,
        broadcastCount: broadcastCount,
        usersByPlatform: usersByPlatform.web,
      })
    }
  }

  handleSubAdminState = () => {
    const { adminRoles } = this.props;
    let subAdmins = 0;
    adminRoles.map(role => {
      subAdmins += role.noOfAdminUsers
    })
    if(subAdmins) return this.setState({ subAdmins: subAdmins, selectedAdminType: '' });
  }

  handleByDropDown = (event) => {
    const { dashboardList } = this.props;
    const { data: { newUsers, messagesSent, usersByPlatform, communityCount } } = dashboardList;
    const stateName = event.target.dataset.select;
    const stateVal = event.target.value;
    switch (stateName) {
      case 'newUsers':
        const newUsersVal = stateVal === 'today' ? newUsers.today : 
                          stateVal === 'thisweek' ? newUsers.thisweek :
                          stateVal === 'thismonth' ? newUsers.thismonth : 'Zero';
        return this.setState({ newUsers: newUsersVal });
      case 'usersByPlatform':
        const usersByPlatformVal = stateVal === 'web' ? usersByPlatform.web : 
                          stateVal === 'android' ? usersByPlatform.android :
                          stateVal === 'ios' ? usersByPlatform.ios : 'Zero';
        return this.setState({ selectedUserPlatform: stateVal, usersByPlatform: usersByPlatformVal })
      default:
        return;
    }
  }

  render() {
    const {
      currentUsers,
      newUsers,
      audioCall,
      videoCall,
      groupCount,
      broadcastCount,
      usersByPlatform,
      selectedUserPlatform,
    } = this.state;
    // const { profile } = this.props;
    // const profilePermission = profile.permission && JSON.parse(profile.permission)
    // const viewPermission = (profilePermission && profilePermission[ 'Dashboard' ][ ModuleActions.view ]) ? true : false;
    // if(!viewPermission) return ( null );
    return (
      <>
        <div className='dashboard pageContainer_inner'>
          <div className='heading-block gap-10'>
            <div className='box_flex'><h4>Analytics Overview</h4></div>
          </div>
          {/* <div className='dashboard_block'>
            <div className='dashboard_left_block'>
              <div>
                <ul className='dashboard_card'>
                  <li>
                    <div className='card_box'>
                      <h5>Total Users</h5>
                      <div className='card_box_col'>
                        <div className='relative'>
                          <i>
                            <svg width="27" height="27" viewBox="0 0 27 27">
                              <rect id="Rectangle_14977" data-name="Rectangle 14977" width="27" height="27" rx="7" fill="#d7faef"/>
                              <g id="Icon" transform="translate(6 5.945)">
                                <circle id="Ellipse_1545" data-name="Ellipse 1545" cx="3.979" cy="3.979" r="3.979" transform="translate(3.437)" fill="#0ccda5"/>
                                <path id="Path_106618" data-name="Path 106618" d="M9.7,19.365a4.518,4.518,0,0,1,.055-6.217q-.532-.041-1.086-.042a10.767,10.767,0,0,0-5.853,1.5A3.1,3.1,0,0,0,1.25,17.085v1.049a1.23,1.23,0,0,0,1.23,1.23Z" transform="translate(-1.25 -4.523)" fill="#0ccda5" fill-rule="evenodd"/>
                                <path id="Subtraction_15" data-name="Subtraction 15" d="M3.8,7.6A3.8,3.8,0,1,1,7.6,3.8,3.8,3.8,0,0,1,3.8,7.6ZM1.917,3.466a.45.45,0,0,0-.319.768L2.774,5.41a.45.45,0,0,0,.637,0L6,2.822a.45.45,0,0,0-.637-.636L3.093,4.456,2.235,3.6A.447.447,0,0,0,1.917,3.466Z" transform="translate(7.959 7.963)" fill="#0ccda5"/>
                              </g>
                            </svg>
                          </i>
                          <h3>
                            139
                            <span>Current Users</span>
                          </h3>
                        </div>
                        <div className='relative'>
                          <i>
                          <svg xmlns="http://www.w3.org/2000/svg" id="Group_87964" data-name="Group 87964" width="27" height="27" viewBox="0 0 27 27">
                            <rect id="Rectangle_14977" data-name="Rectangle 14977" width="27" height="27" rx="7" fill="#ffe3e2"/>
                            <g id="Icon" transform="translate(7 5.72)">
                              <circle id="Ellipse_1545" data-name="Ellipse 1545" cx="3.979" cy="3.979" r="3.979" transform="translate(3.437)" fill="#ff0935"/>
                              <path id="Path_106618" data-name="Path 106618" d="M9.7,19.365a4.518,4.518,0,0,1,.055-6.217q-.532-.041-1.086-.042a10.767,10.767,0,0,0-5.853,1.5A3.1,3.1,0,0,0,1.25,17.085v1.049a1.23,1.23,0,0,0,1.23,1.23Z" transform="translate(-1.25 -4.523)" fill="#ff0935" fill-rule="evenodd"/>
                              <path id="Subtraction_14" data-name="Subtraction 14" d="M3.8,7.6A3.8,3.8,0,1,1,7.6,3.8,3.8,3.8,0,0,1,3.8,7.6Zm-1.44-5.6A.382.382,0,0,0,2,2.36a.361.361,0,0,0,.111.255L3.294,3.8l-.682.682-.5.5A.359.359,0,0,0,2,5.244a.362.362,0,0,0,.619.252L3.8,4.311,4.988,5.5A.36.36,0,1,0,5.5,4.988L4.311,3.8,5.5,2.615A.359.359,0,0,0,5.242,2a.356.356,0,0,0-.254.1L3.8,3.294,2.615,2.107A.363.363,0,0,0,2.359,1.995Z" transform="translate(7.958 7.963)" fill="#ff0935"/>
                            </g>
                          </svg>
                          </i>
                          <h3>
                            30
                            <span>Inactive Users</span>
                          </h3>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                  <div className='card_box'>
                      <h5>New Users</h5>
                      <div className='calender_select_dwn_box'>
                        <i className='calender-icon'><Calendar /></i>
                        <select>
                          <option>Today</option>
                          <option>This Week</option>
                          <option>This Month</option>
                        </select>
                        <i className='arrow-icon'>
                          <svg width="14" height="14" viewBox="0 0 14 14"><path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/></svg>
                        </i>
                      </div>
                      <div className='card_box_col'>
                        <div>
                          <i>
                            <svg xmlns="http://www.w3.org/2000/svg" id="Group_87823" data-name="Group 87823" width="27" height="27" viewBox="0 0 27 27">
                              <rect id="Rectangle_14977" data-name="Rectangle 14977" width="27" height="27" rx="7" fill="#cef4e8"/>
                              <path id="Icon_awesome-user" data-name="Icon awesome-user" d="M6.973,7.969A3.985,3.985,0,1,0,2.988,3.985,3.984,3.984,0,0,0,6.973,7.969Zm2.789,1h-.52a5.419,5.419,0,0,1-4.539,0h-.52A4.185,4.185,0,0,0,0,13.149v1.3a1.5,1.5,0,0,0,1.494,1.494H12.452a1.5,1.5,0,0,0,1.494-1.494v-1.3A4.185,4.185,0,0,0,9.762,8.965Z" transform="translate(6.527 5.531)" fill="#0ccda5"/>
                            </svg>
                          </i>
                          <h3>75</h3>
                          <p>
                            <span>
                              <i>
                                <svg xmlns="http://www.w3.org/2000/svg" width="7.9" height="10.665" viewBox="0 0 7.9 10.665">
                                  <g id="Icon_feather-arrow-up" data-name="Icon feather-arrow-up" transform="translate(0.707 0.5)">
                                    <path id="Path_106363" data-name="Path 106363" d="M18,16.636V7.5" transform="translate(-14.757 -6.971)" fill="none" stroke="#29b88a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                                    <path id="Path_106364" data-name="Path 106364" d="M7.5,10.743,10.743,7.5l3.243,3.243" transform="translate(-7.5 -7.5)" fill="none" stroke="#29b88a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
                                  </g>
                                </svg>
                              </i>
                              17.3%
                            </span>
                            from last month
                          </p>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
              <div>
                <ul className='dashboard_card'>
                  <li>
                    <div className='card_box total_card_bg'>
                      <h5>Total Groups</h5>
                      <div className='card_box_col'>
                        <div>
                          <i>
                            <svg xmlns="http://www.w3.org/2000/svg" id="Group_87823" data-name="Group 87823" width="27" height="27" viewBox="0 0 27 27">
                              <rect id="Rectangle_14977" data-name="Rectangle 14977" width="27" height="27" rx="7" fill="#e2eeff"/>
                              <g id="customer" transform="translate(5.074 6.148)">
                                <ellipse id="Ellipse_1525" data-name="Ellipse 1525" cx="2.81" cy="2.872" rx="2.81" ry="2.872" transform="translate(5.62)" fill="#024fd1"/>
                                <circle id="Ellipse_1526" data-name="Ellipse 1526" cx="1.811" cy="1.811" r="1.811" transform="translate(12.364 2.123)" fill="#024fd1"/>
                                <circle id="Ellipse_1527" data-name="Ellipse 1527" cx="1.811" cy="1.811" r="1.811" transform="translate(0.874 2.123)" fill="#024fd1"/>
                                <path id="Path_106388" data-name="Path 106388" d="M4.417,241.038a2.927,2.927,0,0,0-2.182-.507A2.231,2.231,0,0,0,0,242.753v3.595a.967.967,0,0,0,.968.964c2.3,0,2.027.042,2.027-.1C3,244.665,2.694,242.8,4.417,241.038Z" transform="translate(0 -233.685)" fill="#024fd1"/>
                                <path id="Path_106389" data-name="Path 106389" d="M125.438,239.889a4.887,4.887,0,0,0-3.769.892c-1.806,1.446-1.458,3.394-1.458,5.776a1.155,1.155,0,0,0,1.153,1.153c6.948,0,7.224.224,7.636-.688.135-.309.1-.21.1-3.162A3.99,3.99,0,0,0,125.438,239.889Z" transform="translate(-116.229 -233.029)" fill="#024fd1"/>
                                <path id="Path_106390" data-name="Path 106390" d="M379.992,240.533a2.925,2.925,0,0,0-2.182.507c1.71,1.746,1.422,3.487,1.422,6.174,0,.142-.23.1,1.993.1a1,1,0,0,0,1-1v-3.56A2.231,2.231,0,0,0,379.992,240.533Z" transform="translate(-365.375 -233.687)" fill="#024fd1"/>
                              </g>
                            </svg>
                          </i>
                          <h3>35</h3>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className='card_box audio_card_bg'>
                      <h5>Audio Calls</h5>
                      <div className='card_box_col'>
                        <div>
                          <i>
                            <svg id="Group_87823" data-name="Group 87823" xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27">
                              <rect id="Rectangle_14977" data-name="Rectangle 14977" width="27" height="27" rx="7" fill="#ffefde"/>
                              <path id="Icon_ionic-ios-call" data-name="Icon ionic-ios-call" d="M18.783,16.026A12.362,12.362,0,0,0,16.2,14.3c-.774-.372-1.057-.364-1.605.031-.456.33-.751.636-1.276.521a7.611,7.611,0,0,1-2.563-1.9,7.556,7.556,0,0,1-1.9-2.563c-.111-.529.2-.82.521-1.276.395-.548.406-.831.031-1.605A12.118,12.118,0,0,0,7.683,4.926c-.563-.563-.69-.441-1-.33a5.69,5.69,0,0,0-.916.487,2.762,2.762,0,0,0-1.1,1.161c-.218.471-.471,1.349.816,3.64a20.31,20.31,0,0,0,3.571,4.762h0l0,0,0,0h0a20.389,20.389,0,0,0,4.762,3.571c2.291,1.287,3.169,1.034,3.64.816a2.715,2.715,0,0,0,1.161-1.1,5.691,5.691,0,0,0,.487-.916C19.224,16.716,19.35,16.589,18.783,16.026Z" transform="translate(1.651 1.639)" fill="#f49e49"/>
                            </svg>
                          </i>
                          <h3>108</h3>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className='card_box video_card_bg'>
                      <h5>Video Calls</h5>
                      <div className='card_box_col'>
                        <div>
                          <i>
                            <svg id="Group_87823" data-name="Group 87823" xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27">
                              <rect id="Rectangle_14977" data-name="Rectangle 14977" width="27" height="27" rx="7" fill="#d0effa"/>
                              <path id="Icon_awesome-video" data-name="Icon awesome-video" d="M9.593,4.5H1.364A1.364,1.364,0,0,0,0,5.864v8.229a1.364,1.364,0,0,0,1.364,1.364H9.593a1.364,1.364,0,0,0,1.364-1.364V5.864A1.364,1.364,0,0,0,9.593,4.5ZM15,5.576,11.87,7.733v4.491L15,14.379a.915.915,0,0,0,1.438-.736V6.312A.915.915,0,0,0,15,5.576Z" transform="translate(6.032 3.521)" fill="#0daeea"/>
                            </svg>
                          </i>
                          <h3>24</h3>
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className='graph_box'>Registered Users</div>
          </div> */}
          <div className='dashboard-sections'>
            <section className='all_logs'>
              <div className='broadcasts list'>
                <i className='broadcastsic'>
                  <User/>
                </i>
                <div className='list-logs'>
                  <label>{ currentUsers }</label>
                </div>
                <span>Total number of current users</span>
              </div>
              <div className='broadcasts list'>
                <div className="filter-block">
                  <select data-select='newUsers' onChange={ this.handleByDropDown }>
                    <option value='today'>Today</option>
                    <option value='thisweek'>Last 7 days</option>
                    <option value='thismonth'>Last 30 days</option>
                  </select>
                </div>
                <i className='broadcastsic'>
                  <Groups/>
                </i>
                <div className='list-logs'>
                  <label>{ newUsers }</label>
                </div>
                <span>Total number of new users</span>
              </div>
              <div className='calles list'>
                <div className='audio-video'>
                  <i className='callsic'>
                    <Audio />
                  </i>
                  <div className='list-logs'>
                    <label>
                    { audioCall.calls }<sup>Calls</sup>
                    </label>
                  </div>
                  <span>Audio call</span>
                </div>
                <div className='audio-video'>
                  <i className='videoic'>
                    <Videocamera />
                  </i>
                  <div className='list-logs'>
                    <label>
                      { videoCall.calls }<sup>Calls</sup>
                    </label>
                  </div>
                  <span>Video call</span>
                </div>
              </div>
              <div className='broadcasts list'>
                <i className='broadcastsic'>
                  <Groups />
                </i>
                <div className='list-logs'>
                  <label>{ groupCount }</label>
                </div>
                <span>Total number of groups</span>
              </div>
              {/* <div className='broadcasts list'>
                <i className='broadcastsic'>
                  <Broadcasts />
                </i>
                <div className='list-logs'>
                  <label>{ broadcastCount?.admin }</label>
                </div>
                <span>Total no. of broadcast</span>
              </div> */}
              <div className='broadcasts list'>
                <div className="filter-block">
                  <select data-select='usersByPlatform' onChange={ this.handleByDropDown }>
                    <option value='web'>Web</option>
                    <option value='android'>Android</option>
                    <option value='ios'>iOS</option>
                  </select>
                </div>
                <i className='broadcastsic'>
                  <Platform />
                </i>
                <div className='list-logs'>
                  <label>{ usersByPlatform }</label>
                </div>
                <span> Total number of users registered on { selectedUserPlatform === 'ios' ? 'iOS' : selectedUserPlatform } platform</span>
              </div>
            </section>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { profile } = state
  const { dashboardId, dashboardList, loading } = state.dashboard;
  const { adminRoleId, adminRoles } = state.adminRoles;
  return ({
    profile,
    dashboardId,
    dashboardList,
    loading,
    adminRoleId,
    adminRoles,
  });
};

const mapDispatchtoProps = {
  fetchDashboard: DashboardAction.fetchDashboard,
  fetchAdminRoles:manageAdminRolesActions.fetchAdminRoles,
}

export default connect(mapStateToProps, mapDispatchtoProps)(Dashboard);
